// utils/vimLogger.ts
import { VIMMetrics } from "../slices/vim.slice";
import {
  PredictionPublicationPrice,
  VimDataLog,
  VimPredicted,
} from "@domains/VIM/interfaces/interfaces";

export enum VimActionType {
  EXECUTE_CHANGE = "EXECUTE_CHANGE",
  EXECUTE_RECOMMENDATION = "EXECUTE_RECOMMENDATION",
  GO_MANUAL = "GO_MANUAL",
}

interface VIMLogParams {
  data: { minPublicationPrice: number; publicationPrice: number };
  handleVIMLog: (params: VimDataLog) => void;
  nidSelected?: number;
  selectedOption: PredictionPublicationPrice | null;
  suggestionOption: PredictionPublicationPrice | null;
  user: { country?: string; email: string };
  vimMetrics: VIMMetrics;
}

export const logVIMUpdatePrice = ({
  data,
  user,
  nidSelected,
  vimMetrics,
  suggestionOption,
  selectedOption,
  handleVIMLog,
}: VIMLogParams) => {
  const isRecommendation = suggestionOption !== null;
  const selectedVIM = suggestionOption || selectedOption;

  const getActionType = (
    selectedOption: PredictionPublicationPrice | null,
    suggestionOption: PredictionPublicationPrice | null,
  ): VimActionType => {
    if (selectedOption) {
      return VimActionType.EXECUTE_CHANGE;
    }
    if (suggestionOption) {
      return VimActionType.EXECUTE_RECOMMENDATION;
    }
    return VimActionType.GO_MANUAL;
  };

  handleVIMLog({
    action_type: getActionType(selectedOption, suggestionOption),
    clicks_before: vimMetrics.clicks_15_dias_antes || null,
    country: user.country || "",
    current_price: vimMetrics.precio_actual_de_publicacion || 0,
    days_for_visit: vimMetrics.visitas_para_promesa || null,
    is_recommendation: isRecommendation,
    min_price: Number(data.minPublicationPrice),
    nid: Number(nidSelected),
    recommended_price: vimMetrics.precio_recomendado || null,
    selected_price: selectedVIM?.precio_nuevo || null,
    status: "active",
    ui_version: "1.0.0",
    user_email: user.email,
    variation_abs_gross_margin: selectedVIM?.margen_bruto || null,
    variation_abs_unit: selectedVIM?.unit_tot || null,
    variation_pct_gross_margin: selectedVIM?.margen_bruto_porcentual || null,
    variation_pct_min_price: 3,
    variation_pct_unit: selectedVIM?.unit || null,
    vim_predicted_json: selectedVIM?.probabilidades.map((prob) => ({
      probability: prob.probabilidad,
      visits: prob.visitas,
    })) as VimPredicted[],
    vim_version: "1.0.0",
    visits_before: vimMetrics.visitas_15_dias_antes || null,
    visits_for_promise: vimMetrics.visitas_para_promesa || null,
  });
};
